import { useFormContext } from '@cian/frontend-request-form-widget';
import * as React from 'react';
import { clear } from './clear';
import { restore } from './restore';
import { isLocalStorageAvailable } from '../isLocalStorageAvailable';
import { save } from './save';
export function usePersistentState() {
  var _useFormContext = useFormContext(),
    values = _useFormContext.values;
  var saveCallback = React.useCallback(function () {
    return save(values);
  }, [values]);
  return React.useMemo(function () {
    return {
      valuesToSave: values,
      isAvailable: isLocalStorageAvailable,
      save: saveCallback,
      clear: clear,
      restore: restore
    };
  }, [saveCallback, values]);
}